import React from 'react';
import PartnerList from '../../partners/PartnerList';

const PartnersView = () => {
  return (
    <div className="h-full bg-gray-900 flex flex-col">
      <div className="flex-1 overflow-y-auto">
        <PartnerList />
      </div>
    </div>
  );
};

export default PartnersView;

